// removed by extract-text-webpack-plugin
module.exports = {"vadpLoginRoot":"vadpLoginRoot___1UlJC","logoDiv":"logoDiv___1bWct","logo":"logo___BztEl","nameDiv":"nameDiv___1DTjt","nameCn":"nameCn___3o-e3","nameEn":"nameEn___3qVrJ","right":"right___1I6Xm","rightImage":"rightImage___397bk","image":"image___1xH8c","bottom":"bottom___3qonZ","span":"span___3tXGn","company":"company___2KQed","license":"license___2ifyU","licenseTitle":"licenseTitle___20esP","licenseScroll":"licenseScroll___1qK7q","licenseText":"licenseText___3IJcJ","licenseTextName":"licenseTextName___2KkNy","licenseTextDate":"licenseTextDate___2tRfw","vadpLoginDark":"vadpLoginDark___3VBzO"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/LoginPageForNew/index.less
// module id = 309
// module chunks = 0